/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {uploadBrandLogoImage} from '../api'

export const useMutationUploadBrandLogoImage = createReactQueryMutationHook('uploadBrandLogoImage', uploadBrandLogoImage)
